import { SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const ServiceFooterStyle = styled.div<{ isBodyNoneScroll: boolean }>`
	position: ${(props) => (props.isBodyNoneScroll ? 'fixed' : 'sticky')};
	bottom: 0;
	background: ${(props) => props.theme.sys.gradient.elevation.level1.fill};
	box-shadow: 0 -1px 0 ${SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT}; /* Simulating border-top */
	left: 0;
	right: 0;
	height: 'auto';
	top: 'unset';
	overflow: 'unset';
	z-index: 9;

	.footer-container {
		justify-content: center;
		padding: 12px 0;

		&__inner-container {
			display: flex;
			flex-direction: column;
			width: 100%;
			.info-block {
				${breakPoints({
					'768': 'margin-left: auto;',
				})}
			}

			& .calculation-info-item {
				word-break: keep-all;
			}

			${breakPoints({
				'768': 'flex-direction: row;',
			})}
		}
	}

	.info-block {
		display: flex;
		flex-direction: column;
		gap: 16px;

		${breakPoints({
			'768': 'flex-direction: row; gap: 0;',
		})}
	}

	.calculation {
		flex-grow: 0;
		flex-shrink: 0;
	}

	.marketing {
		flex-grow: 1;
		flex-shrink: 1;
	}
`;
